import React, { useMemo } from 'react';
import { Layout, Menu } from 'antd';
import {
  BarChartOutlined,
  SettingOutlined,
  CarOutlined,
  TeamOutlined,
  GlobalOutlined,
  ThunderboltOutlined,
  ApiOutlined,
  CreditCardOutlined,
  RocketOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './SidebarStyles.css';

const { Sider } = Layout;

function ClientSidebar({ collapsed, onCollapse }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();



  const menuItems = useMemo(() => {
    const baseItems = [
      // { key: 'dashboard', icon: <DashboardOutlined />, label: <span data-tour-id="tour-dashboard">Dashboard</span>, path: '/dashboard/client' },
      // {
      //   key: 'campaigns',
      //   icon: <BarChartOutlined />,
      //   label: <span data-tour-id="tour-campaigns">Campaigns</span>,
      //   path: '/client/campaigns/new-camp-demo'
      // },
      // {
      //   key: 'create-campaign',
      //   icon: <BarChartOutlined />,
      //   label: <span data-tour-id="tour-create-campaign">Create Campaign</span>,
      //   path: '/client/campaigns/new'
      // },
      // {
      //   key: 'vehicles',
      //   icon: <CarOutlined />,
      //   label: <span data-tour-id="tour-vehicles">Vehicle Management</span>,
      //   path: '/client/vehicles'
      // },
      // {
      //   key: 'subscribers-management',
      //   icon: <TeamOutlined />,
      //   label: 'Subscribers Management',
      //   path: '/client/subscribers-management'
      // },
      // {
      //   key: 'notifications',
      //   icon: <BellOutlined />,
      //   label: <span data-tour-id="tour-notifications">Notifications</span>,
      //   path: '/client/notifications'
      // },
      // {
      //   key: 'support',
      //   icon: <MessageOutlined />,
      //   label: <span data-tour-id="tour-support">Support</span>,
      //   path: '/client/support'
      // },
      // {
      //   key: 'settings',
      //   icon: <SettingOutlined />,
      //   label: <span data-tour-id="tour-settings">Settings</span>,
      //   path: '/client/settings'
      // },
      // {
      //   key: 'addins',
      //   icon: <SettingOutlined />,
      //   label: 'Add-Ins Configuration',
      //   path: '/client/addins'
      // },
      { key: 'mcp-map', icon: <GlobalOutlined />, label: 'Map', path: '/client/mcp/map' },
      { key: 'mcp-fleet', icon: <CarOutlined />, label: 'Fleet', path: '/client/mcp/fleet' },
      { key: 'mcp-audiences', icon: <TeamOutlined />, label: 'Audiences', path: '/client/mcp/audiences' },
      { key: 'mcp-automations', icon: <ThunderboltOutlined />, label: 'Automations', path: '/client/mcp/automations' },
      // { key: 'mcp-campaign', icon: <BarChartOutlined />, label: 'Campaign', path: '/client/mcp/campaign' },
      { key: 'mcp-build', icon: <RocketOutlined />, label: 'Build', path: '/client/mcp/build' },
      { key: 'mcp-connections', icon: <ApiOutlined />, label: 'Connections', path: '/client/mcp/connections' },
      { key: 'mcp-settings', icon: <SettingOutlined />, label: 'Settings', path: '/client/mcp/settings' },
      // { key: 'mcp-billing', icon: <CreditCardOutlined />, label: 'Billing', path: '/client/mcp/billing' },

    ];
    return baseItems;
  }, []);

  const menuItemsForAntd = useMemo(() => {
    const mapItems = (items) => items.map(it => ({
      key: it.key,
      icon: it.icon,
      label: it.label,
      type: it.type,
      children: it.children ? mapItems(it.children) : undefined,
    }));
    return mapItems(menuItems);
  }, [menuItems]);

  const findMenuItemByKey = (items, key) => {
    for (const item of items) {
      if (item.key === key) return item;
      if (item.children) {
        const found = findMenuItemByKey(item.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  const selectedKey = useMemo(() => {
    const pathname = location.pathname;
    const findKey = (items) => {
      for (const item of items) {
        if (item.children) {
          const found = findKey(item.children);
          if (found) return found;
        }
        if (item.path && pathname.startsWith(item.path) && item.path !== '/') return item.key;
      }
      return null;
    };
    return findKey(menuItems) || pathname;
  }, [location.pathname, menuItems]);

  const onMenuClick = ({ key }) => {
    const item = findMenuItemByKey(menuItems, key);
    if (item?.path) navigate(item.path);
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      className="sidebar-container"
      width={250}
      collapsedWidth={80}
      trigger={null}
    >
      <div className="sidebar-header">
        <div className="logo-container" style={{ 
          padding: collapsed ? '12px 8px' : '20px 24px 0 24px',
        }}>
          <img 
            src="/SidebarLogo.png" 
            alt="PathMarkr Logo" 
            style={{ 
              height: 'auto',
              maxHeight: collapsed ? '40px' : '50px', 
              maxWidth: '100%', 
              width: 'auto',
              objectFit: 'contain',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={() => onCollapse(!collapsed)}
          />
        </div>
      </div>

      <div className="sidebar-menu-wrapper">
        <Menu
          mode="inline"
          theme="light"
          inlineCollapsed={collapsed}
          selectedKeys={[selectedKey]}
          onClick={onMenuClick}
          items={menuItemsForAntd}
          style={{
            borderRight: 0,
            background: 'transparent',
            marginTop: '0'
          }}
          className="sidebar-menu"
        />
      </div>

      <div className="sidebar-footer" style={{
        borderTop: '2px solid #EAE0CB',
        padding: '12px',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}>
        {/* MCP-style company card */}
        {!collapsed && (
          <div style={{
            borderRadius: 16,
            border: '1px solid #EAE0CB',
            background: '#FBF7F0',
            padding: '12px',
          }}>
            <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.14em', color: '#8A93A7' }}>
              Operator+
            </div>
            <div style={{ marginTop: 4, fontSize: 16, fontWeight: 700, color: '#0F1729', fontFamily: 'var(--font-bricolage)', lineHeight: 1.2 }}>
              {currentUser?.company_name || 'Your company'}
            </div>
            <div style={{ marginTop: 8, fontSize: 12, color: '#8A93A7' }}>
              Your fleet, mapped live
            </div>
            <button
              type="button"
              onClick={() => navigate('/client/mcp/billing')}
              style={{
                marginTop: 12,
                padding: 0,
                background: 'none',
                border: 'none',
                fontSize: 13,
                fontWeight: 600,
                color: '#1F4FE5',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
              }}
            >
              Manage plan
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
            <div style={{ marginTop: 12, fontSize: 10, color: '#8A93A7', letterSpacing: '0.04em' }}>
              v2.3.8 · © 2026 PathMarkr
            </div>
          </div>
        )}
      </div>

    </Sider>
  );
}

export default ClientSidebar;